import React from 'react'
import { contentAreaDataMapper } from 'Helpers/transform'
import LegalPageCardBlock from './LegalPageCardBlock'

const LegalPageBlocks = ({ data, inEditMode }) => {
  const { MainContentArea } = data

  if (!MainContentArea && !inEditMode) return null
  const blockData = contentAreaDataMapper(MainContentArea)

  return (
    <div className="container mx-auto max-w-screen-xl">
      <div className="xl:mx-36 lg:mx-28 md:mx-20 sm:mx-16 mx-12 lg:py-16 md:py-12 sm:py-10 py-6">
      <div data-epi-edit="MainContentArea" className="grid grid-cols-2 lg:gap-y-20 md:gap-y-16 sm:gap-y-12 gap-y-6
                                                      lg:gap-x-32 md:gap-x-24 sm:gap-x-16 gap-x-6">
          {MainContentArea && MainContentArea.length > 0 && MainContentArea.map((block, i) => {
            const { ContentLink } = block
            const { Id } = ContentLink
            return (
              <LegalPageCardBlock data={blockData[Id]} inEditMode={inEditMode} key={i} />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default React.memo(LegalPageBlocks)
